import { Badge } from '../base/badge'

type Event = {
  state: string
}

interface BadgeProps {
  event: Event
}

export const StateBadge = ({ event }: BadgeProps) => {
  switch (event.state) {
    case 'pending': return <Badge color="yellow">pending</Badge>
    case 'confirmed': return <Badge color="green">confirmed</Badge>
    case 'cancelled': return <Badge color="red">cancelled</Badge>
  }
}
